import * as React from 'react';
import './paymentInfoPane.module.scss';
import { observer } from 'mobx-react';
import { inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { SideBar } from './SideBar';
import { BackButtonHeader } from './BackButtonHeader';
import { V3Routes } from '../../../routes';
import { observable } from 'mobx';
import { PaymentInfoPaneState } from './states/PaymentInfoPaneState';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { CardInput } from '../../molecules/payment/CardInput';
import { LoaderRow } from '../../atoms/layout/LoaderRow';

type Props = {
    homeState: HomePageState;
};

@inject('homeState')
@observer
export class PaymentInfoPane extends React.Component<Props> {
    @observable pageState = new PaymentInfoPaneState();

    async componentDidMount() {
        await this.pageState.init();
    }

    render() {
        const {
            formState,
            initialized,
            success,
            submitState: { submitting },
        } = this.pageState;
        if (!initialized) {
            return <LoaderRow />;
        }
        return (
            <div styleName="pane">
                {GlobalStatesV3.viewport.isDesktop && <SideBar activeMenu="payments" />}
                <div styleName="main">
                    <BackButtonHeader to={V3Routes.payments()} />
                    <h2 styleName="h2">お支払い情報の変更</h2>
                    <CardInput formState={formState.cardFormState} />
                    <div styleName="form-submit-button">
                        <Button
                            styleName="button"
                            size="m"
                            type={success ? 'success' : 'primary'}
                            loading={submitting}
                            onClick={() => this.pageState.submit()}
                        >
                            {success ? '更新しました' : '保存する'}
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
}
